import { notificationConstants } from '../constants';
import { notificationRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const notificationActions = {}//Objeto agrupador de funciones

notificationActions.ReSendNip = (nipData) => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    notificationRequests.ReSendNip(nipData)//Ejecución de petición al API
      .then(//Respuesta de promesa
        responseNipData => dispatch(success(responseNipData)),//Respuesta correcta del API
        error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
      )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: notificationConstants.NIP_REQUEST }// => carpeta constants => AuthConstants.js
  }
  function success(responseNipData) { //Respuesta correcta de petición
    return { type: notificationConstants.NIP_SUCCESS, responseNipData } // => carpeta constants => AuthConstants.js
  }
  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: notificationConstants.NIP_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

notificationActions.SendNip = (nipData) => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    notificationRequests.SendNip(nipData)//Ejecución de petición al API
      .then(//Respuesta de promesa
        sendNipData => dispatch(success(sendNipData)),//Respuesta correcta del API
        error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
      )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: notificationConstants.SENDNIP_REQUEST }// => carpeta constants => AuthConstants.js
  }
  function success(sendNipData) { //Respuesta correcta de petición
    return { type: notificationConstants.SENDNIP_SUCCESS, sendNipData } // => carpeta constants => AuthConstants.js
  }
  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: notificationConstants.SENDNIP_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

notificationActions.UpdateMetadata = (nipData) => {
  return dispatch => {
    dispatch(request())//Ejecución de inicialización del "request()"
    notificationRequests.UpdateMetadata(nipData)//Ejecución de petición al API
      .then(//Respuesta de promesa
        responseNipData => dispatch(success(responseNipData)),//Respuesta correcta del API
        error => dispatch(failure(handleErrorMessage(error)))//Respuesta erronea del API
      )
  }

  function request() { //Ingresar la petición hacia las API's (Aquí mostrar gif loader)
    return { type: notificationConstants.NIP_UPDATE_REQUEST }// => carpeta constants => AuthConstants.js
  }
  function success(responseNipData) { //Respuesta correcta de petición
    return { type: notificationConstants.NIP_UPDATE_SUCCESS, responseNipData } // => carpeta constants => AuthConstants.js
  }
  function failure(error) { //Respuesta errone ade petición (Mostrar modal de cortesía)
    return { type: notificationConstants.NIP_UPDATE_FAILURE, error } // => carpeta constants => AuthConstants.js
  }
}

notificationActions.NotificationPINChangePassword = (data) => {
  return dispatch => {
    dispatch(request())
    notificationRequests.NotificationPINChangePassword(data)
      .then(
        notificationCPassData => dispatch(success(notificationCPassData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: notificationConstants.NOTIFICATION_CHANGEPASS_REQUEST }
  }
  function success(notificationCPassData) {
    return { type: notificationConstants.NOTIFICATION_CHANGEPASS_SUCCESS, notificationCPassData }
  }
  function failure(error) {
    return { type: notificationConstants.NOTIFICATION_CHANGEPASS_FAILURE, error }
  }
}

notificationActions.GetQrImage = (data) => {
  return dispatch => {
    dispatch(request())
    notificationRequests.GetQrImage(data)
      .then(
        qrimage => dispatch(success(qrimage)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: notificationConstants.QR_IMAGE_REQUEST }
  }
  function success(qrimage) {
    return { type: notificationConstants.QR_IMAGE_SUCCESS, qrimage }
  }
  function failure(error) {
    return { type: notificationConstants.QR_IMAGE_FAILURE, error }
  }
}

